import { data } from '../../svg/ExpandLess/data';
import { makeIcon } from '../makeIcon';

export const ExpandLess = makeIcon(data, 'expand_less', 'ExpandLess');

export default ExpandLess;
